import { IRequestsData } from 'API';
import { IPersonalDetails } from 'API/personalDetails';
import { MAX_FILE_SIZE_IN_MB } from 'Config';
import { IUserOTPLoginDetails } from 'Context/OTPLoginContext';
import { getCleanFileName } from 'Utils';

export const dataMapper = (
  requestsData: IRequestsData,
  subId: number,
  userData: IUserOTPLoginDetails | IPersonalDetails | null
) => {
  // Build form data object before submit
  const formData = new FormData();
  formData.append('note', requestsData.note);
  formData.append(
    'phoneNumber',
    userData?.mainPhone || (userData as IUserOTPLoginDetails)?.phoneNumber || ''
  );
  formData.append(
    'phonePrefixId',
    userData?.mainPhonePrefix?.toString() ||
      (userData as IUserOTPLoginDetails)?.phonePrefix ||
      ''
  );
  formData.append(
    'shikumSubTypeId',
    subId ? subId.toString() : requestsData.type.toString()
  );

  if (
    requestsData?.requestDataJson &&
    Object.keys(requestsData.requestDataJson).length > 0
  ) {
    formData.append(
      'requestDataJson',
      JSON.stringify(requestsData.requestDataJson)
    );
  }

  if ((userData as IUserOTPLoginDetails)?.hasOwnProperty('token')) {
    formData.append('userOTPLoginDetails.firstName', userData?.firstName || '');
    formData.append('userOTPLoginDetails.lastName', userData?.lastName || '');
    formData.append(
      'userOTPLoginDetails.IsrId',
      (userData as IUserOTPLoginDetails)?.IsrId || ''
    );
    formData.append(
      'userOTPLoginDetails.phonePrefix',
      (userData as IUserOTPLoginDetails)?.phonePrefix || ''
    );
    formData.append(
      'userOTPLoginDetails.phoneNumber',
      (userData as IUserOTPLoginDetails)?.phoneNumber || ''
    );
    formData.append(
      'userOTPLoginDetails.email',
      (userData as IUserOTPLoginDetails)?.email || ''
    );
  }

  Object.entries(requestsData.fieldAttachmentsData).forEach((field, index) => {
    formData.append(`fieldAttachmentsData[${index}].fieldId`, field[1].fieldId);
    Object.entries(field[1].attachments).forEach((file) => {
      const renamedFile = new File([file[1]], getCleanFileName(file[1].name), {
        type: file[1].type,
      });

      formData.append(
        `fieldAttachmentsData[${index}].attachments`,
        renamedFile
      );
    });
  });

  return formData;
};

export const checkFileSize = (file: File) => {
  if (file.size < 1000) {
    return false;
  }
  const MB = file.size / 1024 / 1024;
  return MB < MAX_FILE_SIZE_IN_MB;
};

export const checkExtension = (file: File) => {
  const allowsExtension = [
    'doc',
    'docx',
    'jpg',
    'png',
    'pdf',
    'tif',
    'tiff',
    'jpeg',
  ];
  const fileExt = file.name.split('.').pop();
  if (fileExt && allowsExtension.includes(fileExt.toLowerCase())) {
    return true;
  }
  return false;
};
